import React from "react";
import logoblanco from "../../assets/logoleo.png";
import { Link } from "react-router-dom";
import "./Joinus.css"

import afiliados11 from "../../assets/contenido/afiliados11.jpg";
import afiliados31 from "../../assets/contenido/afiliados31.jpg";
import afiliados3 from "../../assets/contenido/afiliados3.jpg";






export default function Joinus() {
  return (
    <div className="contenedor_joinus">
        <nav className="navbar navbar-light mb-5" id="encabezado">
                    <Link to="/" className="container-fluid">
                        <img
                        src={logoblanco}
                        width="290"
                        height="550"
                        className="img-fluid d-block mx-auto"
                        alt='logoMingga'
                        />
                    </Link>
                </nav>
                <div className="container-fluid" align="left" id="padding">

                <h3 id="titulo" align="center"> <b>LEO FRIENDS PLAN:<br />

            <h5>Help us grow, and receive income for life</h5>

            </b> 
            </h3>



            <br />
            
            <div className="container_bannerus"  align="center">
                <img
                id="imagenajustada"
                className="d-block w-100"
                src={afiliados11}
                width="400"
                height="450"
                alt="..."
                />
                
                <br />
                <br />
                
                </div>
            <br />


                <br />

           <p>
           In order to fulfill the mission of promoting reading and writing in the world, LEO needs to grow, consolidating a large community focused on improving their levels of education and culture, and strengthening their communication skills.
           </p>
           <p>
           The Friends Plan is an invitation from LEO to its members to support this growth, by doing a very simple, easy and quick job: Invite family members, friends and study and work colleagues to join as LEO Members, with a maximum of 20 guests. Once this number is reached, no one else can be invited.
           </p>
           <p>
           For this simple job that we can all do, we will receive permanent income (for life), which will be immediately available in our account.
           </p>
            <br />
            <h3 id="titulo" align="center"> <b>Basic principles of the Friends Plan
            </b> 
            </h3>
            <br />
            <p>
            • Participation is free and voluntary. A member may not participate and continue to enjoy the programs to promote reading, writing and multilingualism offered by ClubLeo. <br />
            • Anyone can be invited. There are no requirements or preconditions. Minors must have the authorization and guardianship of their parents. <br />
            • People from any country in the world can be invited. <br />
            • Withdrawal is free, at any time, without any requirements.



            </p>

            <h3 id="titulo" align="center"> <b></b> </h3>
            <br />
            <h4 id="titulo" align="center"> <b>How the LEO Friends Plan works
                <br /> The principle is simple: invite, and get increasing income, for life
            </b> </h4>

            <br />
            <p>
            1. When we join as members, we create our username and password; the program automatically generates our personal link and creates a "My Account" so we can track our guests and revenue in real time. <br />

            2. We invite our acquaintances to join as LEO members, providing them with our username or sending them the personal link generated by the system to their social media accounts. <br />

            3. When we join as members, the people we invite register our username; and the system accumulates them in our account until we reach the requested 20. After that, the list is closed, and we will no longer be able to invite more people. <br />

            4. According to LEO's 6-degree integration principle, our guests will continue to grow in the country and around the world, and for each of them, LEO will recognize an income, which could reach US$96,000 annually, or a monthly average of US$8,275. <br />     

            Most importantly, CLUBLEO membership is renewed annually, so this income will be permanent, for life. We only need to invite 20 members once, but LEO recognizes our income for life, with the membership and subsequent renewals.


            </p>
            


            <br />
            <h3 id="titulo" align="center"> <b>The Challenge for LEO members: <br />
            Getting our 20 members in 1 month
             <br />
            </b> 
            </h3>
            <br />
            <p>
            If all members manage to recruit our 20 guests within the month following their entry into LEO, from the fourth month onwards we will be able to secure a significant average monthly income of US$8,275, which will be permanent thanks to the annual renewal of the CLUBLEO membership. It is simple, and we can all achieve it very easily: taking advantage of our acquaintances and contacts on social networks.            </p>

            <h3 id="titulo" align="center"> <b>LEO Target Market. <br />
            Potential members
            </b> 
            </h3>

            <div className="container_bannerus1"  align="center">
                <img
                id="imagenajustada"
                className="d-block w-100"
                src={afiliados31}
                width="400"
                height="450"
                alt="..."
                />
                
                </div>
                  <br />
            <br />
            <p>
            CLUBLEO offers in its Digital Library more than 15,000 works in 5 languages, used in more than 100 countries around the world (Appendix), with a population of 1.9 billion people, with 1.675 million over 8 years old with reading ability and 476 million students.        
            </p>
            
            <table className="table_1" align="center"> 
                <tr className="table_2" align="center" >
                    <th className="table_3" align="center">Language</th>
                    <th className="table_3" align="center">Number of works Club Leo</th>
                    <th className="table_3" align="center">Native speakers</th>
                    <th className="table_3" align="center">Age 8+ with Reading Capability</th>
                    <th className="table_3" align="center">Students</th>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">Spanish</td>
                    <td className="table_4" align="center">8.169</td>
                    <td className="table_4" align="center">580</td>
                    <td className="table_4" align="center">510</td>
                    <td className="table_4" align="center">145</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">English</td>
                    <td className="table_4" align="center">5.013</td>
                    <td className="table_4" align="center">678</td>
                    <td className="table_4" align="center">597</td>
                    <td className="table_4" align="center">170</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">French</td>
                    <td className="table_4" align="center">711</td>
                    <td className="table_4" align="center">300</td>
                    <td className="table_4" align="center">264</td>
                    <td className="table_4" align="center">75</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">Italian</td>
                    <td className="table_4" align="center">607</td>
                    <td className="table_4" align="center">85</td>
                    <td className="table_4" align="center">75</td>
                    <td className="table_4" align="center">21</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center">Portuguese</td>
                    <td className="table_4" align="center">614</td>
                    <td className="table_4" align="center">260</td>
                    <td className="table_4" align="center">229</td>
                    <td className="table_4" align="center">65</td>
                </tr>
                <tr className="table_2">
                    <td className="table_4" align="center"> <b>Totals </b></td>
                    <td className="table_4" align="center"><b>15.114</b></td>
                    <td className="table_4" align="center"> <b>1.903</b></td>
                    <td className="table_4" align="center"> <b>1.675</b></td>
                    <td className="table_4" align="center"> <b>476</b> </td>
                </tr>


                </table>
                <br />
                <p>
                Although anyone can join, LEO's priority is the 476 million students and their families in different countries, for whom reading and writing are permanent activities associated with the academic training process, and strengthening their communication skills is key to the success of the educational process. With the annual membership of US$50, each member has access to the downloadable digital library with 15,000 works in 5 languages, valued at more than US$150 thousand. That is, membership allows access to works at an average cost of 0.33 cents each.
                </p>



                <br />
            <h2 id="titulo" align="center"> <b>Friends Plan: <br />
            A valuable opportunity to secure income for life
            <br />
            </b> 
            </h2>
            <br />
            
           <br />
            <div   align="center">
                <img 
                id="imagenajustada"
                className="d-block w-100"
                src={afiliados3}
                height="250"
                alt="..."
                />
                </div>
                <br />
                <h4 id="titulo" align="center"> <b>CLUBLEO <br />
                We are a global community of winners
                </b><br />            </h4>
                <br />

        </div>
    </div>
    
          
                 
  );
}